import { currentPosthogSessionId } from "@/lib/analytics/posthog-session";

const RECENT_LIMIT = 5;

export interface ConvexFailure {
  requestId: string;
  functionName: string | undefined;
  failedAt: string;
}

interface RecordedRequest extends ConvexFailure {
  sessionId: string | undefined;
}

const recentRequests: RecordedRequest[] = [];

export function recordConvexRequestId(
  requestId: string | undefined,
  functionName?: string,
): void {
  if (requestId === undefined) return;
  const existing = recentRequests.findIndex((entry) => entry.requestId === requestId);
  const earlierName = existing === -1 ? undefined : recentRequests[existing]?.functionName;
  if (existing !== -1) recentRequests.splice(existing, 1);
  recentRequests.push({
    requestId,
    functionName: functionName ?? earlierName,
    failedAt: new Date().toISOString(),
    sessionId: currentPosthogSessionId(),
  });
  if (recentRequests.length > RECENT_LIMIT) recentRequests.shift();
}

export function readRecentConvexFailures(): readonly ConvexFailure[] {
  const sessionId = currentPosthogSessionId();
  return recentRequests
    .filter((entry) => entry.sessionId === sessionId)
    .map(({ requestId, functionName, failedAt }) => ({ requestId, functionName, failedAt }))
    .reverse();
}

export function readRecentConvexRequestIds(): readonly string[] {
  return readRecentConvexFailures().map((failure) => failure.requestId);
}
